<template>
  <!-- Footer -->
  <footer class="footer footer-one">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-4">
            <div class="footer-widget footer-about">
              <div class="footer-logo">
                <router-link to="/"
                  ><img src="@/assets/img/Adolfo/logo/logo.png" style="width: 50px;" alt="logo"
                /></router-link>
              </div>
              <div class="footer-about-content">
                <p>
                  Programe fácilmente sus citas médicas conmigo. Conéctese con un profesional de la salud, administre citas y priorice su bienestar.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-3 col-md-4">
                <div class="footer-widget footer-menu">
                  <h2 class="footer-title">Páginas</h2>
                  <ul>
                    <li><router-link to="/">Inicio</router-link></li>
                    <li><router-link to="/acerca-de-mi">Acerca De Mi</router-link></li>
                    <li><router-link to="/contactame">Contáctame</router-link></li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6 col-md-4">
                <div class="footer-widget footer-contact">
                  <h2 class="footer-title">Contacto</h2>
                  <div class="footer-contact-info">
                    <div class="footer-address">
                      <p>
                        <i class="feather-map-pin"></i>HOSPITAL ÁNGELES DEL CARMEN TORRE ESPECIALIDADES MÉDICAS TARASCOS 3473, Monraz, Guadalajara
                      </p>
                    </div>
                    <div class="footer-address">
                      <p><i class="feather-phone-call"></i> +33 382 010 54</p>
                    </div>
                    <div class="footer-address mb-0">
                      <p><i class="feather-mail"></i> dr.anavarro@icloud.com</p>
                    </div>
                    <div class="footer-address mb-0">
                      <p><i class="feather-mail"></i> dr.joseadolfonavarronavarro@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-7">
            <div class="footer-widget">
              <h2 class="footer-title">Redes Sociales</h2>
              <div class="social-icon">
                <ul>
                  <li>
                    <a target="_blank" href="https://www.facebook.com/share/DDzUtwhddaV11m9u/?mibextid=LQQJ4d"
                      ><i class="fab fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.instagram.com/adolfonavarronavarro?igsh=MXhoYm9qaWpvYWI5eg%3D%3D&utm_source=qr"
                      ><i class="fab fa-instagram"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="https://mx.linkedin.com/in/dr-jos%C3%A9-adolfo-navarro-navarro-b00ba711a"
                      ><i class="fab fa-linkedin-in"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <!-- Copyright -->
        <div class="copyright">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="copyright-text">
                <p class="mb-0">
                  Copyright © {{ new Date().getFullYear() }} , develop by JEBM with love
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <!-- Copyright Menu -->
              <div class="copyright-menu">
                <ul class="policy-menu">
                  <li><router-link to="privacy-policy">Privacy Policy</router-link></li>
                  <li>
                    <router-link to="terms-condition">Terms and Conditions</router-link>
                  </li>
                </ul>
              </div>
              <!-- /Copyright Menu -->
            </div>
          </div>
        </div>
        <!-- /Copyright -->
      </div>
    </div>
  </footer>
  <!-- /Footer -->
</template>